/* =========================================================
   Convert goals.
   ---------------------------------------------------------
   Loaded from layout/theme.liquid, in <head>, with `defer`.

   Home for the Convert conversion goals fired from the theme. Each goal is a
   triggerConversion push to window._conv_q, which Convert drains once it has
   loaded, so a goal fired before Convert is ready is queued, not lost.
   ========================================================= */

(function () {
  'use strict';

  function triggerGoal(goalId, label) {
    try {
      window._conv_q = window._conv_q || [];
      window._conv_q.push(['triggerConversion', goalId]);
      console.log('GOAL - ' + label);
    } catch (error) {
      console.warn('Convert goal "' + label + '" failed:', error);
    }
  }

  window.convertGoals = window.convertGoals || {};
  window.convertGoals.trigger = triggerGoal;

  /* ---- Navigation goals: page type A -> page type B ----
     Read from document.referrer on page load, so they need no state and no
     click listeners: a visitor who lands on a product page whose referrer is a
     collection page has gone Collection -> Product, however they got there
     (product card, quick link, search inside the collection...).

     Both ends are classified from the URL path, not from Liquid, so the same
     rules apply to the referrer and to the current page. */
  var NAVIGATION_GOALS = [
    { from: 'collection', to: 'product', id: '1004127066', label: 'Collection -> Product Page' },
    { from: 'home', to: 'product', id: '1004127065', label: 'Home -> Product Page' },
    { from: 'home', to: 'collection', id: '1004127064', label: 'Home -> Collection' }
  ];

  /* Optional market / language prefix: /es, /en-ca, ... */
  var LOCALE_PREFIX = /^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i;

  function pageType(path) {
    path = path.replace(LOCALE_PREFIX, '').replace(/\/+$/, '') || '/';

    if (path === '/') return 'home';
    /* /products/x and /collections/x/products/x are both product pages. */
    if (/^(\/collections\/[^/]+)?\/products\/[^/]+$/.test(path)) return 'product';
    /* /collections/x and its tag-filtered /collections/x/tag. The bare
       /collections list page is not a collection. */
    if (/^\/collections\/[^/]+(\/[^/]+)?$/.test(path)) return 'collection';

    return null;
  }

  /* A reload keeps the original referrer, which would replay the transition. */
  function isReload() {
    var nav = window.performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')[0] 
      : null;
    if (nav) return nav.type === 'reload';
    return !!(window.performance && performance.navigation && performance.navigation.type === 1);
  }

  function trackNavigationGoals() {
    if (!document.referrer || isReload()) return;

    var referrer;
    try {
      referrer = new URL(document.referrer);
    } catch (error) {
      return;
    }

    /* Only internal navigation. */
    if (referrer.host !== window.location.host) return;

    var from = pageType(referrer.pathname);
    var to = pageType(window.location.pathname);
    if (!from || !to) return;

    NAVIGATION_GOALS.forEach(function (goal) {
      if (goal.from === from && goal.to === to) triggerGoal(goal.id, goal.label);
    });
  }

  trackNavigationGoals();

  // convert-test:tapes-by-device-menu-reorder goal START
  /* ---- Menu Interaction (test-specific) ----
     Remove this whole block on deploy AND on cleanup; the navigation goals
     above stay.

     One conversion per tap on a link inside the mobile menu (#nav-ab). Both
     variants render the same menu and B only reorders it with CSS, so the goal
     counts the same thing on each side. The chevrons that open a sub panel
     count: they are the drill-in affordance.

     Capture phase on document, because handlers in abmn-nav.js and inside
     mmenu call stopPropagation on menu clicks. Synthetic clicks are skipped:
     abmn-nav.js forwards a whole-card tap to the chevron with next.click(),
     and that second, untrusted click must not count the same tap twice. */
  var MENU_INTERACTION_GOAL = '1004125448';

  /* Chrome, not menu entries: the logo, the back button, the panel title
     (mmenu wires it up as a second back affordance) and the close button. */
  var MENU_INTERACTION_IGNORE = '.abmn-logobar__link, .abmn-close, .mm-btn_prev, .mm-btn_close, .mm-navbar__title';

  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;

    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('a');
    if (!link || !link.closest('#nav-ab')) return;
    if (link.matches(MENU_INTERACTION_IGNORE)) return;

    triggerGoal(MENU_INTERACTION_GOAL, 'Menu Interaction');
  }, true);
  // convert-test:tapes-by-device-menu-reorder goal END
})();
